module.exports = {
  siteName: "CD ",
  copyright: "Copyright © All rights reserved |  ",
  logoPath: "/image/logo.png",
  merchantArrays: [
    "edx",
    "coursera",
    "pluralsight",
    "skillshare",
    "choicedekho",
    "upgrad",
  ],
  apiURL: "https://staging-backend.choicedekho.com/api"
  // apiURL: "https://api.choicedekho.com/api",
};
